<!-- Page Wrapper -->
<div class="page-wrapper" style="min-height: 347px;">
    <div class="content container-fluid">
        <div class="bg-white page-border">
            <!--page body contant -->
            <!--header-->
            <div class="row row-replace add-m-b">
                <div class="col-md-6 col-9 col-p h5"><i class="fa fa-coffee"></i>Order List </div>
                <div class="col-md-6 col-3 top-corner-items col-p">
                    <!-- <button class="btn btn-primary btn-sm"><i class="fa fa-plus"></i> Manpower Requisition</button> -->
                </div>
            </div>
            <!--end header-->
            <div class="row row-replace justify-content-center b-b">
                <div class="col-md-11">
                    <div class="form-group row">
                        <label class="col-sm-1 col-form-label">From</label>
                        <div class="col-sm-4">
                          <input type="date" class="form-control"  placeholder="Date from">
                        </div>
                        <label class="col-sm-1 col-form-label">To</label>
                        <div class="col-sm-4">
                          <input type="date" class="form-control" placeholder="Date to">
                        </div>
                        <div class="col-sm-2 text-center">
                            <button class="btn btn-sm btn-primary mob-m">Search</button>
                          </div>
                      </div>
                </div>
            </div>

<!--card view-->
            <div class="row row-replace justify-content-md-center" style="background-image:url('assets/img/pantry/coffeeback.jpg')">
                <div class="col-md-5 border shadow m-t-10 cus-r bg-white">
                    <div class="row">
                        <div class="col-12 bg-g-light">
                            <h3 class="m-0"><span>Rohit Kumar Singh</span>
                                <span class="float-right">09878778767</span>
                            </h3>
                        </div>
                        <div class="col-3 text-center bg-primary text-white pt-10">
                            <p class="m-0">Seat No</p>
                            <h1 class="m-0">2345</h1>
                        </div>
                        <div class="col-7 cad-pb bg-white">
                            <!-- <p class="m-0">Ramesh kumar singh</p> -->
                            <p class="m-0">
                                <span> <img src="assets/img/pantry/coffee.png" width="30"></span>
                                <span class="h5 ml-10">Coffee</span>
                                <span class="h5 ml-10">2</span>
                            </p>
                            <p class="m-0">
                                <span> <img src="assets/img/pantry/salty.png" width="30"></span>
                                <span class="h5 ml-10">Salty</span>
                                <span class="h5 ml-10">2</span>
                            </p>
                            <p class="m-0">
                                <span> <img src="assets/img/pantry/salty.png" width="30"></span>
                                <span class="h5 ml-10">Salty</span>
                                <span class="h5 ml-10">2</span>
                            </p>
                        </div>
                        <div class="col-2 cad-pb bg-white">
                            <button class="btn btn-sm btn-primary cus-btn"><i class="fa fa-bell"></i></button>
                        </div>
                    </div>
                </div>

                <div class="col-md-5 border shadow m-t-10 cus-r bg-white">
                    <div class="row">
                        <div class="col-12 bg-g-light">
                            <h3 class="m-0"><span>Rohit Kumar Singh</span>
                                <span class="float-right">09878778767</span>
                            </h3>
                        </div>
                        <div class="col-3 text-center bg-primary text-white pt-10">
                            <p class="m-0">Seat No</p>
                            <h1 class="m-0">2345</h1>
                        </div>
                        <div class="col-7 cad-pb bg-white">
                            <!-- <p class="m-0">Ramesh kumar singh</p> -->
                            <p class="m-0">
                                <span> <img src="assets/img/pantry/coffee.png" width="30"></span>
                                <span class="h5 ml-10">Coffee</span>
                                <span class="h5 ml-10">2</span>
                            </p>
                            <p class="m-0">
                                <span> <img src="assets/img/pantry/salty.png" width="30"></span>
                                <span class="h5 ml-10">Salty</span>
                                <span class="h5 ml-10">2</span>
                            </p>
                            <!-- <p class="m-0">
                                <span> <img src="assets/img/pantry/salty.png" width="30"></span>
                                <span class="h5 ml-10">Salty</span>
                                <span class="h5 ml-10">2</span>
                            </p> -->
                        </div>
                        <div class="col-2 cad-pb bg-white">
                            <button class="btn btn-sm btn-primary cus-btn"><i class="fa fa-bell"></i></button>
                        </div>
                    </div>
                </div>

                <div class="col-md-5 border shadow m-t-10 cus-r bg-white">
                    <div class="row">
                        <div class="col-12 bg-g-light">
                            <h3 class="m-0"><span>Rohit Kumar Singh</span>
                                <span class="float-right">09878778767</span>
                            </h3>
                        </div>
                        <div class="col-3 text-center bg-primary text-white pt-10">
                            <p class="m-0">Seat No</p>
                            <h1 class="m-0">2345</h1>
                        </div>
                        <div class="col-7 cad-pb bg-white">
                            <!-- <p class="m-0">Ramesh kumar singh</p> -->
                            <p class="m-0">
                                <span> <img src="assets/img/pantry/coffee.png" width="30"></span>
                                <span class="h5 ml-10">Coffee</span>
                                <span class="h5 ml-10">2</span>
                            </p>
                            <!-- <p class="m-0">
                                <span> <img src="assets/img/pantry/salty.png" width="30"></span>
                                <span class="h5 ml-10">Salty</span>
                                <span class="h5 ml-10">2</span>
                            </p>
                            <p class="m-0">
                                <span> <img src="assets/img/pantry/salty.png" width="30"></span>
                                <span class="h5 ml-10">Salty</span>
                                <span class="h5 ml-10">2</span>
                            </p> -->
                        </div>
                        <div class="col-2 cad-pb bg-white">
                            <button class="btn btn-sm btn-primary cus-btn"><i class="fa fa-bell"></i></button>
                        </div>
                    </div>
                </div>
                
            </div>



<!-- table view -->
            <!-- <div class="row m-t-10">
                <div class="col-12">
                       <div class="table-responsive">
                           <table class="table table-row-fixed">
                               <thead>
                               <tr class="bg-primary text-white">
                                  <th class="w1">Sr No.</th>
                                  <th>Items List</th>
                                  <th>Qty.</th>
                                  <th>Seat No</th>
                                  <th>Name</th>
                                  <th>Mobile No</th>
                                  <td>Action</td>
                               </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="w1">1</td>
                                    <td>1</td>
                                    <td>1</td>
                                    <td>1</td>
                                    <td>1</td>
                                    <td>1</td>
                                    <td>
                                        <div class="btn-group-sm">
                                           
                                            <button class="btn btn-info ml-10"><i class="fa fa-bell"></i></button>
                                            
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                               
                           </table>
                        </div>
                   </div>
            </div> -->

            
             
             

      <!--end page body contant -->
        </div>
    </div>
</div>
<!-- /Page Wrapper -->           

